<template>
  <div class="w-100">
    <div class="custom-control custom-radio custom-control-inline">
      <input :id="yesField" v-model="form[field]" :value="true" type="radio" class="custom-control-input">
      <label :for="yesField" class="custom-control-label">{{ $t('yes') }}</label>
    </div>
    <div class="custom-control custom-radio custom-control-inline">
      <input :id="noField" v-model="form[field]" :value="false" type="radio" class="custom-control-input">
      <label :for="noField" class="custom-control-label">{{ $t('no') }}</label>
    </div>
    <div v-if="details && form[field]">
      <div>{{ $t(root + '.' +details) }}</div>
      <div v-if="type == 2">
        <textarea v-model="form[details]" class="form-control" rows="4"/>
      </div>
      <div v-if="type == 1">
        <input v-model="form[details]" type="text" class="form-control"></textarea>
      </div>
      <form-error :form="form" :field="details"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YesNoDetails',

  props: {
    form: { type: Object, required: true },
    field: { type: String, required: true },
    details: { type: String, default: null },
    root: { type: String, default: 'accompanying_sheet' },
    type: { type: Number, default: 1 } // 1 input, 2 textarea
  },

  computed: {
    noField () {
      return this.field + 'No'
    },

    yesField () {
      return this.field + 'Yes'
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/YesNoDetails.vue